import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusDescription',
  standalone: true // Standalone pipe
})
export class StatusDescriptionPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'ATIVA': return 'Ativa';
      case 'VENCIDA': return 'Vencida';
      case 'CASSADA': return 'Cassada';
      case 'AGUARDANDO_ASSINATURA': return 'Aguardando';
      case 'CANCELADA': return 'Cancelada';
      default: return value;
    }
  }
}
